import { SwiperSlide, Swiper } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import Car from '../car';

export default function SuggestedVehicles({ suggestedVehicles, trans }) {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    if (!suggestedVehicles || suggestedVehicles.length === 0) return null;

    return (
        <section className="sec rv vis" style={{ background: 'var(--bg)', padding: '50px 0' }}>
            <div className="ctn">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.5rem', padding: '0 8px' }}>
                    <span style={{ width: '4px', height: '18px', borderRadius: '2px', background: 'var(--g)' }}></span>
                    <h3 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--t1)', margin: 0 }}>
                        {trans('new:suggested_vehicles')}
                    </h3>
                </div>

                <div className="suggested-swiper-wrapper" style={{ width: '100%', overflow: 'hidden', padding: '10px 0' }}>
                    <style>{`
                        .suggested-swiper-wrapper .swiper-slide {
                            height: auto;
                            display: flex;
                            justify-content: center;
                        }
                        .suggested-swiper-wrapper .swiper-slide > div {
                            width: 100%;
                            display: flex;
                        }
                    `}</style>
                    <Swiper
                        observer={true}
                        observeParents={true}
                        rebuildOnUpdate={true}
                        spaceBetween={20}
                        slidesPerView={1.1}
                        breakpoints={{
                            576: { slidesPerView: 1.8 },
                            768: { slidesPerView: 2.4 },
                            1024: { slidesPerView: 3.2 },
                            1200: { slidesPerView: 3.8 }
                        }}
                        initialSlide={0}
                        style={{ padding: '10px 5px 30px' }}
                    >
                        {suggestedVehicles?.map((vehicle, index) => (
                            <SwiperSlide key={vehicle.productTarget + index}>
                                <div>
                                    <Car
                                        group={vehicle.group}
                                        slug={vehicle.productTarget}
                                        year={vehicle.year}
                                        colorID={vehicle.colorID}
                                        gifts={vehicle.countGifts}
                                        groupType={vehicle.carGroupID}
                                        modelType={vehicle.type}
                                        hybridImage={vehicle.hybridImage}
                                        brandImage={vehicle.BrandImage}
                                        discountPrice={vehicle.discount}
                                        ProductId={vehicle.productID}
                                        img={vehicle.image}
                                        name={lang === 'ar' ? (vehicle.description || vehicle.name) : (vehicle.descriptionEn || vehicle.nameEn)}
                                        brand={vehicle.brand}
                                        brandID={vehicle?.brandID}
                                        category={vehicle.categor}
                                        minPrice={vehicle.minPrice}
                                        miniDownPayment={vehicle?.miniDownPayment}
                                        Tax={vehicle.Tax}
                                        RateCareDiscount={vehicle.RateCareDiscount}
                                        newCar={vehicle.newCar}
                                        hybird={vehicle.hybird}
                                        desc={vehicle.desc}
                                        modelTypes={vehicle?.modelDescription?.replace(vehicle?.brand, '')}
                                        link={'/car/overview/' + vehicle?.sn + '/' + vehicle.productTarget}
                                        brandIcon={vehicle.brandIcon}
                                        type={vehicle.type}
                                        showPric={vehicle.showPric}
                                        buyOnline={vehicle?.buyOnline}
                                        goBuyDerict={true}
                                        colorName={vehicle?.colorName ? vehicle?.colorName : null}
                                        carData={vehicle}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}
